import { PropsWithChildren } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpFromBracket } from "@fortawesome/sharp-regular-svg-icons";
import styles from "./add-document-button.module.scss";

type AddDocumentButtonProps = {
  onClick: () => void;
  description: string;
};

const AddDocumentButton = ({
  onClick,
  description,
  children,
}: PropsWithChildren<AddDocumentButtonProps>) => (
  <button type="button" className={styles.addDocumentButton} onClick={onClick}>
    <div className={styles.addDocumentButtonContent}>
      <span className={styles.addDocumentButtonLabel}>{children}</span>
      <span className={styles.addDocumentButtonDescription}>{description}</span>
    </div>
    <div className={styles.addDocumentButtonIconContainer}>
      <FontAwesomeIcon icon={faArrowUpFromBracket} />
    </div>
  </button>
);

export default AddDocumentButton;
